import _ from 'lodash';

export const Layouts = {
  MAIN: require('../components/MainChannelComponent').default
};

export const ChannelTypes = {
  MUSIC: 0,
  NON_MUSIC: 1
};

function wipFor(channel) {
  return {
    type: ChannelTypes.NON_MUSIC,
    channel,
    name: 'Work in Progress',
    shortName: 'WIP.AM',
    track: '/audio/radio radi0.mp3',
    poster: '/images/'
  };
}

function generateChannels() {
  const chans = {
    '0': {
      layout: Layouts.MAIN,
      'channel': 0,
      name: 'The Network',
      shortName: 'OTHER-PEOPLE.NETWORK',
      'track': '/audio/radio radi0.mp3'
    },
    '102': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 102,
      'name': 'Condensed Matter Systems',
      'poster': '/images/CMS.FM.jpg',
      'shortName': 'CM.FM',
      'track': '/audio/0002 4-Audio-4.mp3'
    },
    '105': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 105,
      'name': 'Multiverse FM',
      'poster': '/images/MU.FM.jpg',
      'shortName': 'MU.FM',
      'track': '/audio/CODE.mp3'
    },
    '108': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 108,
      'name': 'The Object Spoke to Me . PSD',
      'poster': '/images/OSTM.FM.jpg',
      'shortName': 'OSTM.FM',
      'track': '/audio/2 of everything object spoke to me.mp3'
    },
    '111': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 111,
      'name': 'Hot Jungle',
      'poster': '/images/HJ.FM-SCANNED.jpg',
      'shortName': 'HJ.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '114': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 114,
      'name': 'Spells of Angels',
      'poster': '/images/SOA.AM.jpg',
      'shortName': 'SOA.AM',
      'track': '/audio/0001 8-Audio 1 (I900).mp3'
    },
    '117': {
      layout: Layouts.MAIN,
      'channel': 117,
      'name': 'Science Needs A Clown',
      'poster': '/images/SNC.FM.jpg',
      'shortName': 'SNC.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '12': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 12,
      'name': 'Pomegranates In The Sky',
      'poster': '/images/PIS.FM.jpg',
      'shortName': 'POMLIVE.TOKYO',
      'track': '/audio/pomegranates in the sky.mp3'
    },
    '123': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 123,
      'name': 'QUESTIONS THE SHADOW KNEW',
      'poster': '/images/QTSK.FM.jpg',
      'shortName': 'QTSK.FM',
      'track': '/audio/QUESTIONS THE SHADOW KNEW.mp3'
    },
    '126': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 126,
      'name': 'SLAUGHTER . FM',
      'poster': '/images/s-laughter.gif',
      'shortName': 'STO.P',
      'track': '/audio/SLAUGHTER.mp3'
    },
    '129': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 129,
      'name': 'Jane Said Of My Idol That Art Was Doing Its Job, Tearing Away its Dead Flesh',
      'poster': '/images/JSOMITAWDIJTAIDF.FM.gif',
      'shortName': 'JSOMITAWDIJTADF.FM',
      'track': '/audio/jane sai dof my idol.mp3'
    },
    '132': {
      layout: Layouts.MAIN,
      'channel': 132,
      'name': 'CNN',
      'poster': '/images/CNN.FM.jpg',
      'shortName': 'CNN.FM',
      'track': '/audio/cnn.mp3'
    },
    '135': {
      layout: Layouts.MAIN,
      'channel': 135,
      'name': 'Billionaire fm',
      'poster': '/images/B.FM (1).jpg',
      'shortName': 'B.FM',
      'track': '/audio/billionaire fm.mp3'
    },
    '138': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 138,
      'name': 'The Tennis Underground',
      'poster': '/images/TTU.FM.jpg',
      'shortName': 'TTU.FM',
      'track': '/audio/tennis underground.mp3'
    },
    '141': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 141,
      'name': 'History Has A Way With Words',
      'poster': '/images/HHWWW.FM.jpg',
      'shortName': 'THEMEAN.SISTHEWAY',
      'track': '/audio/Kill Me And Shoot Me And Stab Me.mp3'
    },
    '144': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 144,
      'name': 'The Future Has No Birds',
      'poster': '/images/TFHNB.AM.jpg',
      'shortName': 'TFHNB.AM',
      'track': '/audio/THE FUTURE HAS NO BIRDS.mp3'
    },
    '147': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 147,
      'name': 'Red Flag ',
      'poster': '/images/RF.FM.jpg',
      'shortName': 'RF.FM',
      'track': '/audio/RED FLAG.mp3'
    },
    '15': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 15,
      'name': 'Hardcore Ambient',
      'poster': '/images/HA.FM.jpg',
      'shortName': 'HA.FM',
      'track': '/audio/hardcore ambient III.mp3'
    },
    '150': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 150,
      'name': 'The Eternal has an accent . fm',
      'poster': '/images/TEHAA.FM.jpg',
      'shortName': 'TEHAA.FM',
      'track': '/audio/eternal accent.mp3'
    },
    '153': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 153,
      'name': 'The Revolver On The Left',
      'poster': '/images/ROTL.FM.jpg',
      'shortName': 'LOL',
      'track': '/audio/left revolver.mp3'
    },
    '156': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 156,
      'name': 'American Dream Radio',
      'poster': '/images/ADR.FM.jpg',
      'shortName': 'ADR.FM',
      'track': '/audio/american dream.mp3'
    },
    '159': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 159,
      'name': 'Young Me With Young You',
      'poster': '/images/YMWYY.FM-scanned (1).jpg',
      'shortName': 'YMWYY.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '162': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 162,
      'name': 'Everyone gets into Heaven',
      'poster': '/images/EGH.FM.jpg',
      'shortName': 'EGH.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '165': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 165,
      'name': 'Un Coup de D\u00e9s Jamais nabolira le hazard',
      'poster': '/images/UCDDJNLH.FM.jpg',
      'shortName': 'UCDJLH.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '168': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 168,
      'name': 'Deep Symmetry',
      'poster': '/images/deep symetryy 3 (3).jpg',
      'shortName': 'DS.FM',
      'track': '/audio/DEEP SYMMETRY.mp3'
    },
    '171': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 171,
      'name': 'AMERICA IS PERFECT',
      'poster': '/images/AP.FM.jpg',
      'shortName': 'AP.FM',
      'track': '/audio/star spangled tune.mp3'
    },
    '174': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 174,
      'name': 'Ad Me To You',
      'poster': '/images/AMTY.FM.jpg',
      'shortName': 'AMTY.FM',
      'track': '/audio/ad me to you.mp3'
    },
    '177': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 177,
      'name': 'Mirrors Still Reflect If They Break',
      'poster': '/images/MSRITB.FM.jpg',
      'shortName': 'MSRITB.FM',
      'track': '/audio/20160126 115829-1.mp3'
    },
    '18': wipFor(18),
    '180': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 180,
      'name': 'LET\'S CHANGE THE SYSTEM',
      'poster': '/images/LCTS.FM.jpg',
      'shortName': 'LCTS.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '183': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 183,
      'name': 'Mashcast',
      'poster': '/images/MC.FM.jpg',
      'shortName': 'MC.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '186': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 186,
      'name': 'Playing With You',
      'poster': '/images/PWY.FM.jpg',
      'shortName': 'PWY.FM',
      'track': '/audio/playing with you.mp3'
    },
    '189': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 189,
      'name': 'MAKE AMERICA GREAT AGAIN',
      'poster': '/images/',
      'shortName': 'MAGA',
      'track': '/audio/Make America Great Again Spanish Song.mp3'
    },
    '192': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 192,
      'name': 'code . fm',
      'poster': '/images/CD.FM.jpg',
      'shortName': 'CD.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '195': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 195,
      'name': 'La resistencia de ayer es la resistencia de hoy',
      'poster': '/images/LRARH.FM.jpg',
      'shortName': 'LRDRH.FM',
      'track': '/audio/resistancia final.mp3'
    },
    '198': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 198,
      'name': 'Sex Radio',
      'poster': '/images/SEX RADIO FINAL.jpeg',
      'shortName': 'OPSR.FM',
      'track': '/audio/sex radio2.mp3'
    },
    '201': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 201,
      'name': 'Standard Model',
      'poster': '/images/SM.FM.jpg',
      'shortName': 'SM.FM',
      'track': '/audio/1 5-Audio.mp3'
    },
    '204': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 204,
      'name': 'Super Symmetry',
      'poster': '/images/SS.FM.jpg',
      'shortName': 'SS.FM',
      'track': '/audio/super symmetry.mp3'
    },
    '207': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 207,
      'name': 'Whose World is This?',
      'poster': '/images/WMYMM.Fm.jpg',
      'shortName': 'WMYMM.FM',
      'track': '/audio/whose world is this 333_.mp3'
    },
    '21': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 21,
      'name': 'Waves and Sirens',
      'poster': '/images/WAS.FM.jpg',
      'shortName': 'WAS.FM',
      'track': '/audio/Waves _ Sirens.mp3'
    },
    '210': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 210,
      'name': 'Our World',
      'poster': '/images/OW.AM-400px.jpg',
      'shortName': 'OW.AM',
      'track': '/audio/OPM01.mp3'
    },
    '213': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 213,
      'name': 'Famous Heart',
      'poster': '/images/FH.FM.jpg',
      'shortName': 'FH.FM',
      'track': '/audio/A FAMOUS HEART.mp3'
    },
    '216': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 216,
      'name': 'FALLACY',
      'poster': '/images/FC.FM.jpg',
      'shortName': 'FC.FM',
      'track': '/audio/10 - Fallacy.mp3'
    },
    '219': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 219,
      'name': 'Live from Gaza',
      'poster': '/images/LFG.FM.jpg',
      'shortName': 'LFG.FM',
      'track': '/audio/live in gaza.mp3'
    },
    '222': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 222,
      'name': 'VOICES.FM',
      'poster': '/images/V.FM.gif',
      'shortName': 'V.FM',
      'track': '/audio/SONTAG IMAGINATION.mp3'
    },
    '225': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 225,
      'name': 'JUMP RADIO',
      'poster': '/images/jump fence.jpg',
      'shortName': 'JRAD.FM',
      'track': '/audio/cumbia mix 2.mp3'
    },
    '228': wipFor(228),
    '231': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 231,
      'name': 'The Whole World Is Watching',
      'poster': '/images/TWWIW.FM.jpg',
      'shortName': 'NONSILE.NT',
      'track': '/audio/whole world.mp3'
    },
    '234': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 234,
      'name': 'Flood Fm',
      'poster': '/images/F.FM (1).jpg',
      'shortName': 'FLOOD.FM',
      'track': '/audio/flood fm.mp3'
    },
    '237': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 237,
      'name': 'Live from Las vegas',
      'poster': '/images/LFLV.FM.jpg',
      'shortName': 'LFLV.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '24': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 24,
      'name': 'Feet FM',
      'poster': '/images/F.FM.jpg',
      'shortName': 'F.FM',
      'track': '/audio/FEET FM.mp3'
    },
    '240': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 240,
      'name': 'Yankee Yankee Yankee Cuidado Cuidado !!!',
      'poster': '/images/YANKEE YANKEE YANKEE CUIDADO.jpg',
      'shortName': 'YYYC.FM',
      'track': '/audio/YANKEE YANKEE YANKEE CUIDADO !!!.mp3'
    },
    '243': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 243,
      'name': 'pray . fm',
      'poster': '/images/PRAY FM FINAL3 (1).jpg',
      'shortName': 'PRAY.FM',
      'track': '/audio/gospel radio.mp3'
    },
    '246': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 246,
      'name': 'IT SOUNDED LIKE THE FINALE OF THE 4TH OF JULY',
      'poster': '/images/finale.jpg',
      'shortName': 'FINALE.AM',
      'track': '/audio/finale.mp3'
    },
    '249': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 249,
      'name': 'A New Kind Of Kool Aid',
      'poster': '/images/A NEW KIND OF KOOLAID.jpg',
      'shortName': 'ANKOKA.AM',
      'track': '/audio/A NEW KIND OF KOOL AID.mp3'
    },
    '252': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 252,
      'name': 'Mini Infiniti',
      'poster': '/images/Mini Infinity . am.jpeg',
      'shortName': 'MI.AM',
      'track': '/audio/1 2-Audio 1.mp3'
    },
    '255': {
      layout: Layouts.MAIN,
      'channel': 255,
      'name': 'Spa Theory ',
      'poster': '/images/ST.AM.jpg',
      'shortName': 'ST.AM',
      'track': '/audio/radio radi0.mp3'
    },
    '258': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 258,
      'name': 'Near A Burning Flame',
      'poster': '/images/NEAR A BURNING FLAME FM.jpeg',
      'shortName': 'NABF.FM',
      'track': '/audio/0001 4-Audio1 2.mp3'
    },
    '261': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 261,
      'name': 'RESIST STANCE',
      'poster': '/images/resist stance (1).jpg',
      'shortName': 'RESIST-STANCE.FM',
      'track': '/audio/resist stance.mp3'
    },
    '264': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 264,
      'name': 'NIAR LIRPA',
      'poster': '/images/NIAR.jpg',
      'shortName': 'NIAR.FM',
      'track': '/audio/niar lirpa.mp3'
    },
    '267': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 267,
      'name': 'Matta Clark Demolitions',
      'poster': '/images/mc demolitionss (1).jpg',
      'shortName': 'MCD.AM',
      'track': '/audio/matta clark demolitions.mp3'
    },
    '27': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 27,
      'name': 'I SHOOT LIKE I TALK',
      'poster': '/images/SLIT.FM.jpg',
      'shortName': 'ISLIT.FM',
      'track': '/audio/I SHOOT LIKE I TALK.mp3'
    },
    '270': {
      layout: Layouts.MAIN,
      type: ChannelTypes.MUSIC,
      'channel': 270,
      'name': 'You Can Be Young Forever',
      'poster': '/images/YCBYF.FM.jpg',
      'shortName': 'YCBYF.FM',
      'track': '/audio/you can be young forever.mp3'
    },
    '273': {
      layout: Layouts.MAIN,
      type: ChannelTypes.NON_MUSIC,
      'channel': 273,
      'name': 'Silence . fm',
      'poster': '/images/silenceFM.jpg',
      'shortName': 'S.FM',
      'track': '/audio/121 Human Heartbeat (Slow, Pounding).mp3'
    },
    '276': {
      type: ChannelTypes.MUSIC,
      'channel': 276,
      'name': 'VTGNIKE IS FREE !!!',
      'poster': '/images/VIF.FM.jpg',
      'shortName': 'VIF.FM',
      'track': '/audio/01 Stimulate.mp3'
    },
    '279': {
      type: ChannelTypes.MUSIC,
      'channel': 279,
      'name': 'Against All Logic',
      'poster': '/images/AAL FULL LENGTH image.jpg',
      'shortName': 'AALISME',
      'track': '/audio/AAL SET.mp3'
    },
    '282': {
      type: ChannelTypes.MUSIC,
      'channel': 282,
      'name': 'HOME',
      'poster': '/images/',
      'shortName': 'HOME.FM',
      'track': '/audio/Home.mp3'
    },
    '285': {
      type: ChannelTypes.MUSIC,
      'channel': 285,
      'name': 'LOS COLORES NO EXISTEN',
      'poster': '/images/LCNE.FM.jpg',
      'shortName': 'LCNE.FM',
      'track': '/audio/los colores loop.mp3'
    },
    '288': {
      type: ChannelTypes.MUSIC,
      'channel': 288,
      'name': 'Other People Radio',
      'poster': '/images/OP RADIO3 (2).jpg',
      'shortName': 'OPR.FM',
      'track': '/audio/other people mix 3.mp3'
    },
    '291': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 291,
      'name': 'Geography of Heaven',
      'poster': '/images/GOH.AM.jpg',
      'shortName': 'GOH.AM',
      'track': '/audio/Lunch-Lydia_Conspiracy-of-Women PREVIEW.mp3'
    },
    '294': {
      type: ChannelTypes.MUSIC,
      'channel': 294,
      'name': 'EVERYWHERE I GO ',
      'poster': '/images/EIG.FM.jpg',
      'shortName': 'EIG.FM',
      'track': '/audio/everywhere.mp3'
    },
    '297': {
      type: ChannelTypes.MUSIC,
      'channel': 297,
      'name': 'Change Your Name',
      'poster': '/images/AA.FM.jpg',
      'shortName': 'AA.FM',
      'track': '/audio/change your name.mp3'
    },
    '3': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 3,
      'name': 'Traffic Princess',
      'poster': '/images/400TP.FM.jpg',
      'shortName': 'TP.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '30': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 30,
      'name': 'Heaven\'s Floor',
      'poster': '/images/HF.AM.gif',
      'shortName': 'HF.AM',
      'track': '/audio/heavens flor3.mp3'
    },
    '300': wipFor(300),
    '303': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 303,
      'name': 'Life Radio',
      'poster': '/images/life radio.jpg',
      'shortName': 'LR.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '306': {
      type: ChannelTypes.MUSIC,
      'channel': 306,
      'name': 'ELEGY FOR THE EMPYRE',
      'poster': '/images/elegy empire 2 (1).jpg',
      'shortName': 'EFTE.FM',
      'track': '/audio/elegy.mp3'
    },
    '309': {
      type: ChannelTypes.MUSIC,
      'channel': 309,
      'name': 'TOOK ME OUT',
      'poster': '/images/TMO.FM.jpg',
      'shortName': 'TMO.FM',
      'track': '/audio/7- Took me out.mp3'
    },
    '312': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 312,
      'name': 'THE NUMBER AND THE SIREN',
      'poster': '/images/TNATS.FM.jpg',
      'shortName': 'NUMB.AM',
      'track': '/audio/chance fm 2.mp3'
    },
    '315': {
      type: ChannelTypes.MUSIC,
      'channel': 315,
      'name': 'AESTHETIC OF RESISTANCE OR RESISTANCE OF AESTHETIC',
      'poster': '/images/RA AR.jpg',
      'shortName': 'OR.FM',
      'track': '/audio/System Audio 20160816 0214.mp3'
    },
    '318': {
      type: ChannelTypes.MUSIC,
      'channel': 318,
      'name': 'POMEGRANATES',
      'poster': '/images/',
      'shortName': 'ST',
      'track': '/audio/pomegranates new.mp3'
    },
    '321': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 321,
      'name': 'REGULAR HYPNOSYS',
      'poster': '/images/regular hypnosis final.jpg',
      'shortName': 'R.HYP',
      'track': '/audio/REGULAR HYPNOSIS.mp3'
    },
    '324': {
      type: ChannelTypes.MUSIC,
      'channel': 324,
      'name': 'What Made You Made Me',
      'poster': '/images/BV.FM.jpg',
      'shortName': 'WMUME',
      'track': '/audio/ambient set.mp3'
    },
    '327': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 327,
      'name': 'RADIO 333',
      'poster': '/images/333R.FM.gif',
      'shortName': 'R333.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '33': {
      type: ChannelTypes.MUSIC,
      'channel': 33,
      'name': 'WE WEREN\'T MADE FOR THESE TIMES',
      'poster': '/images/IJWMFTT.FM.jpg',
      'shortName': 'IJWMFTT.FM',
      'track': '/audio/We weren\'t made for these times.mp3'
    },
    '330': {
      type: ChannelTypes.MUSIC,
      'channel': 330,
      'name': 'NYMPHS',
      'poster': '/images/',
      'shortName': 'EP',
      'track': '/audio/nymphs.mp3'
    },
    '333': {
      type: ChannelTypes.MUSIC,
      'channel': 333,
      'name': 'SIRENS',
      'poster': '/images/sirens.jpg',
      'shortName': 'LP',
      'track': '/audio/SIRENS for NETWORK.mp3'
    },
    '999': {
      type: ChannelTypes.MUSIC,
      'channel': 999,
      'name': 'SIRENS (DIGITAL)',
      'poster': '/images/sirens.jpg',
      'shortName': 'FL',
      'track': '/audio/radio radi0.mp3'
    },
    '36': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 36,
      'name': 'Water In Heaven',
      'poster': '/images/WIH.jpg',
      'shortName': 'WIH.FM',
      'track': '/audio/Water in Heaven.mp3'
    },
    '39': {
      type: ChannelTypes.MUSIC,
      'channel': 39,
      'name': 'System of a Downey',
      'poster': '/images/SOAD.AM-front.jpg',
      'shortName': 'SOAD.AM',
      'track': '/audio/The Looking Glass1.mp3'
    },
    '42': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 42,
      'name': 'the answer is in the question . fm',
      'poster': '/images/TAIITQ.FM.jpg',
      'shortName': 'TAIITQ.FM',
      'track': '/audio/the answer is in the question.mp3'
    },
    '45': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 45,
      'name': 'The Answer Starts With The Word Ideology',
      'poster': '/images/TASWTWI.FM.jpg',
      'shortName': 'TASWTWI.FM',
      'track': '/audio/The Answer to the QUESTION Starts With the Word _ IDEOLOGY _ part I.mp3'
    },
    '48': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 48,
      'name': 'In the Face of Defeat FM',
      'poster': '/images/ITFOD.FM.jpg',
      'shortName': 'ITFOD.FM',
      'track': '/audio/TIME.mp3'
    },
    '51': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 51,
      'name': 'Present Choice',
      'poster': '/images/PC.AM.jpg',
      'shortName': 'PC.AM',
      'track': '/audio/resent choice.mp3'
    },
    '54': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 54,
      'name': 'Bible . Fm',
      'poster': '/images/B.FM.jpg',
      'shortName': 'B.FM',
      'track': '/audio/bible.mp3'
    },
    '57': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 57,
      'name': 'The Rejects . AM',
      'poster': '/images/TR.AM.jpg',
      'shortName': 'TR.AM',
      'track': '/audio/radio radi0.mp3'
    },
    '6': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 6,
      'name': 'CHANCE FM',
      'poster': '/images/C.FM.gif',
      'shortName': 'C.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '60': {
      type: ChannelTypes.MUSIC,
      'channel': 60,
      'name': 'The Rejects . FM',
      'poster': '/images/TR.FM.jpg',
      'shortName': '4NASANDG.ZA :(',
      'track': '/audio/rejects 1.mp3'
    },
    '63': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 63,
      'name': 'This house is on Fire!',
      'poster': '/images/sriracha.jpg',
      'shortName': 'LEVAN.GOD',
      'track': '/audio/A BURNING HOUSE.mp3'
    },
    '66': {
      type: ChannelTypes.MUSIC,
      'channel': 66,
      'name': 'RED BULL SPONSORED REVOLUTION',
      'poster': '/images/RBSR.FM.jpg',
      'shortName': 'RESI.ST',
      'track': '/audio/RED BULL SPONSORED REVOLUTION.mp3'
    },
    '69': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 69,
      'name': 'Our God Flag FM',
      'poster': '/images/OGF.FM-BORDER.jpg',
      'shortName': '333START.SLIKEDIS',
      'track': '/audio/OUR GOD FLAG.mp3'
    },
    '72': {
      type: ChannelTypes.MUSIC,
      'channel': 72,
      'name': 'Naked Bieber FM',
      'poster': '/images/NB.FM.gif',
      'shortName': 'NB.FM',
      'track': '/audio/naked bieber.mp3'
    },
    '75': {
      type: ChannelTypes.MUSIC,
      'channel': 75,
      'name': 'Fucking Classics',
      'poster': '/images/FC.FM.gif',
      'shortName': 'FC.FM',
      'track': '/audio/Filthy Rich Drop by Crystal.mp3'
    },
    '78': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 78,
      'name': 'Pop Harvey',
      'poster': '/images/PH.AM.jpg',
      'shortName': 'PH.FM',
      'track': '/audio/pop harvey.mp3'
    },
    '81': {
      type: ChannelTypes.MUSIC,
      'channel': 81,
      'name': 'Labour of Love',
      'poster': '/images/LOL.FM.jpg',
      'shortName': 'LOL.FM',
      'track': '/audio/FS.mp3'
    },
    '84': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 84,
      'name': 'Vito\'s Room',
      'poster': '/images/VR.AM.jpg',
      'shortName': 'VR.AM',
      'track': '/audio/Acconci-Vito_The-Bristol-Project_2001.mp3'
    },
    '87': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 87,
      'name': 'Radio Radio',
      'poster': '/images/RR.AM.jpg',
      'shortName': 'RR.FM',
      'track': '/audio/radio radi0.mp3'
    },
    '9': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 9,
      'name': 'You Don\'t Know What Love Is',
      'poster': '/images/YDKWLI.FM.jpg',
      'shortName': 'YDKWLI.FM',
      'track': '/audio/you dont now what love is.mp3'
    },
    '90': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 90,
      'name': 'Tv Buddha',
      'poster': '/images/TVB.AM.jpg',
      'shortName': 'TVB.AM',
      'track': '/audio/SPIRITUAL 1.mp3'
    },
    '93': {
      type: ChannelTypes.NON_MUSIC,
      'channel': 93,
      'name': 'Century of the Self',
      'poster': '/images/COS.FM.jpg',
      'shortName': 'COS.FM',
      'track': '/audio/The Century of the Self (Full Documentary).mp3'
    },
    '96': {
      type: ChannelTypes.MUSIC,
      'channel': 96,
      'name': 'The Vacuum has no Symmetry',
      'poster': '/images/VS.FM.jpg',
      'shortName': 'VS.FM',
      'track': '/audio/super coool!!!!.mp3'
    },
    '99': {
      type: ChannelTypes.MUSIC,
      'channel': 99,
      'name': 'Eternal inflation',
      'poster': '/images/EI.FM.jpg',
      'shortName': 'EI.FM',
      'track': '/audio/0003 13-Audio-1.mp3'
    }
  };

  _.forEach(chans, (val) => {
    val.layout = Layouts.MAIN;
    if (val.poster) {
      val.largePoster = val.poster.replace(/images\//g, 'images/large/');
    }
  });

  return chans;
}

export const Channels = generateChannels();

export function channelsOfType(type) {
  return _.pickBy(Channels, (v) => v.type === type);
}



// WEBPACK FOOTER //
// ./src/data/channels.js